<template>
  <div v-if="loading" class="flex col-12 p2 items-center justify-center">
    <Loader class="flex" />
  </div>
  <div v-else class="flex col-12 p2 items-center white-bg flex-wrap">
    <div class="flex col-12 items-center justify-center flex-wrap mb2">
      <div class="flex col-12 items-center justify-center bold">Mes reçus de paiement</div>
      <!-- <div class="flex col-12 items-center justify-center">Factures acquittées</div> -->
    </div>
    <div v-if="receiptsResponse.success && receiptsResponse.data.length" class="flex col-12 flex-wrap p2">
      <div
        v-for="(receipt, index) in receiptsResponse.data"
        :key="index"
        class="flex col-12 relative p2 items-center flex-wrap list-item"
      >
        <div class="flex col-12 sm-col-6 md-col-6 lg-col-6 list-item-text p2 justify-center">
          {{
            `Reçu du paiement du ${receipt.created} - ${handlePrice(receipt.total)} €`
          }}
        </div>
        <div
          class="flex col-12 sm-col-6 md-col-6 lg-col-6 button-container"
        >
          <a
            :href="receipt.url"
            target="_blank"
            class="flex rounded caps py1 px4 white red-bg download-button pointer center"
          >Telecharger mon reçu</a>
        </div>
      </div>
    </div>
    <div v-else class="flex col-12 p2 items-center justify-center">Aucun reçu disponible!</div>
  </div>
</template>

<script>
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { onBeforeMount, ref, reactive } from 'vue';
import { getReceiptsInfo } from '@/mixins/requests';
import Loader from '@/components/common/Loader';

export default {
  components: { Loader },
  setup () {
    const store = useStore();
    const route = useRoute();
    const { uuid } = route.params;
    const orders = ref(store.state.user.orders || []);
    const order = reactive(orders.value.find(o => o.uuid === uuid) || {});
    const loading = ref(false);
    const receiptsResponse = ref({});

    onBeforeMount(async () => {
      loading.value = true;
      await getReceiptsInfo({ orderUuid: order.uuid })
        .then(async r => {
          receiptsResponse.value = r;
        })
        .catch(err => ({ success: false, message: err }));
      loading.value = false;
    });
    const handlePrice = price => (parseInt(price) / 100).toFixed(2);
    return { loading, receiptsResponse, handlePrice };
  }
};
</script>

<style lang="scss" scoped>
@media (max-width: 40em){
  .list-item-text{
    text-align: center;
  }
  .button-container {
    justify-content: center;
  }
  .download-button {
    padding: 0.5rem 1rem;
  }
  .list-item {
    border-bottom: 1px solid #ccc;
  }
}
@media (min-width: 40em){
  .list-item-text::before {
    content: '•';
    position: absolute;
    left: 0;
    color: black;
    font-size: 1rem;
  }
}
</style>>
